import type { FilterState } from './types'
import { DEFAULT_TENANT_ID as SHARED_DEFAULT_TENANT_ID } from 'shared/utils/tenantContext'

export const DEFAULT_TENANT_ID = SHARED_DEFAULT_TENANT_ID
export const PAGE_SIZE = 20

export const PERMIT_TYPE_OPTIONS = [
  { value: 'all', label: '\u0e17\u0e38\u0e01\u0e1b\u0e23\u0e30\u0e40\u0e20\u0e17' },
  { value: 'HOT_WORK', label: 'Hot Work' },
  { value: 'COLD_WORK', label: 'Cold Work' },
  { value: 'CONFINE_WORK', label: 'Confine Work' },
]

export const STATUS_OPTIONS = [
  { value: 'all', label: '\u0e17\u0e38\u0e01\u0e2a\u0e16\u0e32\u0e19\u0e30' },
  { value: 'P0090', label: 'Opened' },
  { value: 'P9009', label: 'Close' },
]

export const todayInput = () => {
  const date = new Date()
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export const createDefaultFilters = (): FilterState => ({
  search: '',
  workAreaId: 'all',
  permitType: 'all',
  status: 'all',
  workDate: todayInput(),
})
